import React, { Fragment, useEffect } from 'react';
import { Switch } from 'react-router-dom';

import UserTracker from 'Containers/Analytics/UserTracker';
import MeasurementProtocolListener from 'Containers/Analytics/measurementProtocolListener';
import PageTitle from 'Components/PageTitle';
import GuidedPracticeProvider from 'Context/GuidedPracticeProvider';

import { GenSwitchRoute, MainRoute } from '../../Util/Route';
import LanguageSelector from '../../Containers/LanguageSelector';
import { getRouteBaseName } from '../../Util/pathUtils';
import AnnouncementProvider from '../../HOC/Announcement';
import { useConfig } from '../../Context/ConfigContext';

import getRoutes from './routes';
import AppUrlListener from './AppUrlListener';

const RouteApp = ({ myProfile, capacitorContext }) => {
  const { isNative, routeListener, getUserProvider, getUserInfo } = capacitorContext;
  const {
    translationMode,
    isAppUrlListenerEnabled,
    enablePDPAConsent,
    PDPAConsentVersion,
    myCoursesUrl,
    measurementProtocol,
    ...config
  } = useConfig();
  const pageSuffix = config?.global?.pageSuffix ?? '';
  const service = config?.service ?? '';
  const menus = getRoutes({ ...config, myCoursesUrl, isNative });

  useEffect(() => {
    if (myProfile && enablePDPAConsent) {
      const userConsent = myProfile?.userConsent;
      const redirectToDashboard = () => {
        const destinationURL = new URL(myCoursesUrl);
        destinationURL.searchParams.set('continue', window.location.href);
        window.location.href = destinationURL.toString();
      };

      if (userConsent) {
        const allUserConsentFields = Object.keys(userConsent);

        if (allUserConsentFields.length < 2) {
          redirectToDashboard();
          return;
        }

        const shouldShowPDPAModal = allUserConsentFields.some(
          (consentKey) =>
            !userConsent[consentKey] ||
            userConsent[consentKey].acceptedVersion !== PDPAConsentVersion
        );

        if (shouldShowPDPAModal) return redirectToDashboard();
      } else {
        redirectToDashboard();
      }
    }
  }, [PDPAConsentVersion, enablePDPAConsent, myCoursesUrl, myProfile]);

  return (
    <MainRoute basename={getRouteBaseName()}>
      {isAppUrlListenerEnabled && (
        <AppUrlListener
          routeListener={routeListener}
          getUserProvider={getUserProvider}
          getUserInfo={getUserInfo}
        ></AppUrlListener>
      )}
      <UserTracker />
      {!!measurementProtocol && <MeasurementProtocolListener />}
      <PageTitle title={`${service} ${pageSuffix}`} />
      <AnnouncementProvider>
        {/* FIXME: ไม่แน่ใจว่าส่ง provider ข้าม route ต้องทำไงต่อ เลยมาเจอว่าวางตรงนี้แล้วส่งข้ามได้ ลองถามแชทแล้วทำตามก็ไม่ได้ เผื่อมีท่าที่ดีกว่านี้ครับ */}
        <GuidedPracticeProvider>
          <Fragment>
            <Switch>
              <GenSwitchRoute menus={menus} />
            </Switch>
            {translationMode && (
              <div style={{ textAlign: 'right', marginTop: 8 }}>
                <LanguageSelector
                  languages={[
                    { lang: 'en', display: 'English' },
                    { lang: 'th', display: 'ไทย' },
                  ]}
                />
              </div>
            )}
          </Fragment>
        </GuidedPracticeProvider>
      </AnnouncementProvider>
    </MainRoute>
  );
};

export default RouteApp;
